import { ReducerBuilder } from './reducerBuilder';
import { NetworkState } from '../store/networkState';
import { NetworkConnected, NetworkDisconnected } from '../actions/network';

export const networkReducer =
    new ReducerBuilder<NetworkState>({
        isConnected: undefined,
    })
    .actionCase(NetworkConnected, (state, action) => ({
        isConnected: true
    }))
    .actionCase(NetworkDisconnected, (state, action) => ({
        isConnected: false
    }))
    .build();
